export default __webpack_public_path__ + "static/article-how-to-sell-your-car-for-the-best-price-3f32f9e82f0bc8bb29e8011ce59b5650.jpg";